module.exports = __webpack_public_path__ + "img/icon_lianjie.a4d99dc9.png";